export default __webpack_public_path__ + "static/media/download.f9c61df2.svg";